import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Button } from '@thd-olt-component-react/button';
import { Image } from '@thd-olt-component-react/image';
import { Loader } from '@thd-olt-component-react/loader';

import { getCents, getDollars } from '../helpers';

const OrderSampleContent = ({
  channel,
  children,
  dimensionText,
  handleClick,
  link,
  loading,
  loadingSample,
  multipleSamples,
  oosMessage,
  price,
  samplesOOS
}) => {
  const isMobile = channel === 'mobile';

  const subTextClasses = classnames('order-sample__sub-text', {
    'order-sample__sub-text--link': link
  });

  const orderSampleInfoClasses = classnames('order-samples__info', {
    'order-sample__info--link': link && !isMobile,
    'order-sample__info--multiSampleLink': link && multipleSamples && isMobile
  });

  const subtext = (!multipleSamples && !link)
    ? `Order a ${dimensionText} sample`
    : 'Order a sample';

  const defaultButtonText = multipleSamples ? 'Choose Sample' : 'Add Sample to Cart';
  const buttonContent = loading
    ? <Loader active small />
    : defaultButtonText;
  return (
    <div className="order-sample">
      <div className="order-sample__details">
        <Image
          alt="more-options-icon"
          className="order-sample__icon"
          src="https://assets.homedepot-static.com/images/v1/more-options.svg"
        />
        <div className={orderSampleInfoClasses}>
          {link ? (
            <span>{children}</span>
          ) : (
            <span className="order-sample__sub-text--title">{children}</span>
          )}
          {!samplesOOS
            && (
              <div className={subTextClasses}>
                {
                  !link ? (
                    subtext
                  ) : (
                    <Button
                      data-testid="order-sample-cta"
                      link
                      onClick={handleClick}
                      style={{ width: 'auto' }}
                    >
                      {loadingSample ? <Loader active small />
                        : (
                          <span>
                            {subtext}
                            {!!price && (
                              <span>&nbsp;for&nbsp;
                                <span className="order-sample__sub-text--bold">
                                  {price < 1
                                    ? <span>{getCents(price)}&cent;</span>
                                    : <span>${getDollars(price)}</span>}
                                </span>
                              </span>
                            )}
                          </span>
                        )}
                    </Button>
                  )
                }
                {!!price && !link && (
                  <span>&nbsp;for&nbsp;
                    <span className="order-sample__sub-text--bold">
                      {price < 1
                        ? <span>{getCents(price)}&cent;</span>
                        : <span>${getDollars(price)}</span>}
                    </span>
                  </span>
                )}
              </div>
            )}
          {oosMessage && samplesOOS
            && (
              <div className="order-sample__out-of-stock">
                <span>Out of Stock</span>
              </div>
            )}
        </div>
      </div>
      {!link && (
        <Button
          className="order-sample__button"
          dark
          data-testid="order-sample-cta"
          disabled={samplesOOS}
          onClick={handleClick}
          outline
        >
          {samplesOOS ? 'Out Of Stock' : buttonContent}
        </Button>
      )}
    </div>
  );
};

OrderSampleContent.propTypes = {
  channel: PropTypes.string,
  children: PropTypes.node.isRequired,
  dimensionText: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  link: PropTypes.bool,
  loading: PropTypes.bool,
  loadingSample: PropTypes.bool,
  multipleSamples: PropTypes.bool,
  oosMessage: PropTypes.bool,
  price: PropTypes.number,
  samplesOOS: PropTypes.bool
};

OrderSampleContent.defaultProps = {
  channel: PropTypes.oneOf(['desktop', 'mobile']),
  link: false,
  loading: false,
  loadingSample: false,
  multipleSamples: false,
  oosMessage: false,
  price: NaN,
  samplesOOS: false
};

export default OrderSampleContent;
